<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="ارزش‌های حرفه‌ای شغل"
        description="این بخش به توضیح ارزش‌های حرفه‌ای مرتبط با شغل می‌پردازد تا درک بهتری از آن‌ها برای انتخاب صحیح و متناسب با شغل داشته باشید."
    />

    <JobProfessionalValuesTableSection/>

    <JobProfessionalValuesSection class="mt-5"/>

<NavigationButtons @next="$emit('next')" @prev="$emit('prev')" />
  </div>
</template>

<script>
import NavigationButtons from "@/components/JobDescription/GeneralComponents/NavigationButtons.vue";
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import JobProfessionalValuesSection from "@/components/JobDescription/StepThree/JobProfessionalValuesSection.vue";
import JobProfessionalValuesTableSection from "@/components/JobDescription/StepThree/JobProfessionalValuesTableSection.vue";

export default {
  components: {JobProfessionalValuesTableSection, JobProfessionalValuesSection, JobDescriptionHeader, NavigationButtons},
};
</script>
